import api from "./api";
import { getUser } from "../services/Auth";

export const listarSeparadores = async () => {
  try {
    let usuario = await getUser();
    const separadores = await api.get(
      `estabelecimentos/${usuario.estabelecimento._id}/separadores`,
    );
    return separadores.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarSeparador = async (separador, usuario) => {
  try {
    const user = await api.post("/registrar", usuario);
    if (user) {
      separador = { ...separador, usuario: user.data.usuario._id };
      const separadores = await api.post(`/separadores`, separador);
      return separadores.data;
    }
  } catch (error) {
    throw error;
  }
};

export const EditarSeparador = async (separador, usuario, id_separador, id_usuario) => {
  try {
    const user = await api.put(`/usuarios/${id_usuario}`, usuario);
    if (user) {
      const separadores = await api.put(`/separadores/${id_separador}`, separador);
      return separadores.data;
    }
  } catch (error) {
    throw error;
  }
};

export const DeletarSeparador = async (id) => {
  try {
    const separadores = await api.delete(`/separadores/${id}`);
    return separadores.data;
  } catch (error) {
    throw error;
  }
};
